/* KEMAKS — Glavni JavaScript */

function scrollToWiz(e) {
  if (e) e.preventDefault();
  var el = document.getElementById('wizard-section');
  if (el) el.scrollIntoView({behavior:'smooth'});
}

function scrollToProducts(e) {
  if (e) e.preventDefault();
  var el = document.getElementById('products-section');
  if (el) el.scrollIntoView({behavior:'smooth'});
}

function toggleMobileMenu() {
  var menu = document.getElementById('mobile-menu');
  var overlay = document.getElementById('mobile-overlay');
  if (!menu) return;
  var isOpen = menu.classList.contains('open');
  if (isOpen) {
    menu.classList.remove('open');
    overlay && overlay.classList.remove('open');
    document.body.style.overflow = '';
  } else {
    menu.classList.add('open');
    overlay && overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
}

/* Custom cookie banner ONEMOGOČEN 19.7.2026 — glej theme.liquid.
   Shopify zdaj samodejno upravlja consent (Settings → Customer privacy). */

function updateCartCount() {
  fetch('/cart.js')
    .then(function(r){return r.json();})
    .then(function(cart) {
      var badge = document.getElementById('cart-count');
      if (!badge) return;
      if (cart.item_count > 0) {
        badge.textContent = cart.item_count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    });
}

/* Opomba: updateCartCount() se NE kliče več ob vsakem nalaganju strani —
   značka je že pravilno izrisana na strežniku prek {{ cart.item_count }}
   (glej theme.liquid), zato je bil ta fetch ob vsakem obisku strani odveč.
   Kliče se samo po dejanski spremembi košarice (dodajanje/odstranjevanje),
   kar je že poskrbljeno drugod v tej datoteki. */

/* ================= CART DRAWER ================= */

function openCartDrawer(e) {
  if (e) e.preventDefault();
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  if (!drawer) return;
  drawer.classList.add('open');
  overlay.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  renderCartDrawer();
}

function closeCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  if (!drawer) return;
  drawer.classList.remove('open');
  overlay.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

/* Brezplačna dostava nad 100 € (10000 = cent) — enako kot drugod na strani */
var CART_FREE_SHIPPING_THRESHOLD = 10000;

function renderCartDrawer() {
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var itemsEl = document.getElementById('cart-drawer-items');
      var countEl = document.getElementById('cart-drawer-count');
      var shipText = document.getElementById('cart-drawer-shipping-text');
      var shipFill = document.getElementById('cart-drawer-shipping-fill');
      if (countEl) countEl.textContent = cart.item_count > 0 ? cart.item_count : '';

      if (shipText && shipFill) {
        var remaining = CART_FREE_SHIPPING_THRESHOLD - cart.total_price;
        if (remaining > 0) {
          shipText.textContent = 'Do brezplačne dostave ti manjka še ' + (remaining/100).toFixed(2).replace('.', ',') + ' €!';
          shipFill.style.width = Math.min(100, (cart.total_price / CART_FREE_SHIPPING_THRESHOLD) * 100) + '%';
        } else {
          shipText.textContent = '✓ Brezplačna dostava odklenjena!';
          shipFill.style.width = '100%';
        }
      }

      if (!itemsEl) return;
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-drawer-empty">Košarica je prazna.</div>';
        var summaryElEmpty = document.getElementById('cart-drawer-summary');
        if (summaryElEmpty) summaryElEmpty.innerHTML = '';
        return;
      }

      var html = '';
      var totalSavings = 0;
      cart.items.forEach(function(item){
        var compareAt = (typeof KEMAKS_COMPARE_PRICES !== 'undefined') ? KEMAKS_COMPARE_PRICES[String(item.variant_id)] : null;
        var itemSavings = 0;
        if (compareAt) {
          itemSavings = (compareAt - item.price) * item.quantity;
          if (itemSavings > 0) totalSavings += itemSavings;
        }
        var itemUrl = item.url || '#';
        html += '<div class="cd-item" data-key="' + item.key + '">'
          + '<a class="cd-item-link" href="' + itemUrl + '" onclick="closeCartDrawer()">'
          + '<div class="cd-item-img">' + (item.image ? '<img src="' + item.image + '" width="64" height="64" alt="' + item.product_title + '">' : '') + '</div>'
          + '<div class="cd-item-body">'
          + '<div class="cd-item-name">' + item.product_title + '</div>'
          + (item.variant_title ? '<div class="cd-item-variant">' + item.variant_title + '</div>' : '')
          + '</div>'
          + '</a>'
          + '<div class="cd-item-qty">'
          + '<button type="button" onclick="cartDrawerChangeQty(\'' + item.key + '\', ' + (item.quantity - 1) + ')">−</button>'
          + '<span>' + item.quantity + '</span>'
          + '<button type="button" onclick="cartDrawerChangeQty(\'' + item.key + '\', ' + (item.quantity + 1) + ')">+</button>'
          + '</div>'
          + '<div class="cd-item-right">'
          + (itemSavings > 0 ? '<div class="cd-item-was">' + ((compareAt * item.quantity)/100).toFixed(2).replace('.', ',') + ' €</div>' : '')
          + '<div class="cd-item-price">' + (item.final_line_price/100).toFixed(2).replace('.', ',') + ' €</div>'
          + (itemSavings > 0 ? '<div class="cd-item-savings">Prihranite ' + (itemSavings/100).toFixed(2).replace('.', ',') + ' €</div>' : '')
          + '<button type="button" class="cd-item-remove" onclick="cartDrawerChangeQty(\'' + item.key + '\', 0)" aria-label="Odstrani">✕</button>'
          + '</div>'
          + '</div>';
      });
      itemsEl.innerHTML = html;

      var summaryEl = document.getElementById('cart-drawer-summary');
      if (summaryEl) {
        var summaryHtml = '';
        if (totalSavings > 0) {
          summaryHtml += '<div class="cart-drawer-summary-row cart-drawer-summary-savings"><span>Prihranki</span><span>−' + (totalSavings/100).toFixed(2).replace('.', ',') + ' €</span></div>';
        }
        summaryHtml += '<div class="cart-drawer-summary-row cart-drawer-summary-total"><span>Skupaj</span><span>' + (cart.total_price/100).toFixed(2).replace('.', ',') + ' €</span></div>';
        summaryEl.innerHTML = summaryHtml;
      }
    })
    .catch(function(){
      var itemsEl = document.getElementById('cart-drawer-items');
      if (itemsEl) itemsEl.innerHTML = '<div class="cart-drawer-empty">Napaka pri nalaganju košarice.</div>';
    });
}

function cartDrawerChangeQty(key, qty) {
  if (qty < 0) qty = 0;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: key, quantity: qty})
  })
    .then(function(){ renderCartDrawer(); updateCartCount(); })
    .catch(function(){ /* tiho spodleti, uporabnik lahko poskusi znova */ });
}

/* ================= PREDNAROČILO (jesen/zima premor naročil do marca) =================
   Vsak poskus dodajanja izdelka v košarico — kjerkoli na strani — se najprej
   ustavi na pojavnem oknu (glej #preorder-overlay v layout/theme.liquid), ki
   stranko obvesti, da čistila trenutno niso na voljo, in ponudi prednaročilo
   po znižani ceni. Če potrdi ("Oddaj prednaročilo"), se v ozadju tiho aktivira
   15% popust koda PRED15 (enak vzorec kot WRA_UPSELL_DISCOUNT_CODE v
   main-product.liquid — Shopify-jev standardni /discount/<koda> klic, ki
   nastavi popust-cookie brez preusmeritve), šele nato se prvotno dejanje
   (dodajanje v košarico) dejansko izvede.

   V Shopify Adminu (Discounts) ustvari kodo z natanko imenom "PRED15" —
   15% popust na celotno naročilo, veljavna do konca prednaročilne akcije
   (marec). Če je pop-up iz kakega razloga odstranjen s strani (npr. na
   custom strani brez layout/theme.liquid), gatePreorder() dejanje izvede
   takoj naprej, da nakup ni blokiran. */
var PREORDER_DISCOUNT_CODE = 'PRED15';
var pendingPreorderAction = null;

function gatePreorder(proceedFn) {
  var overlay = document.getElementById('preorder-overlay');
  if (!overlay) { proceedFn(); return; }
  pendingPreorderAction = proceedFn;
  overlay.style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

function closePreorderPopup() {
  var overlay = document.getElementById('preorder-overlay');
  if (overlay) overlay.style.display = 'none';
  document.body.style.overflow = '';
  pendingPreorderAction = null;
}

function confirmPreorder() {
  var action = pendingPreorderAction;
  var overlay = document.getElementById('preorder-overlay');
  var btn = document.getElementById('preorder-cta-btn');
  if (btn) { btn.disabled = true; btn.style.opacity = '0.7'; }
  fetch('/discount/' + PREORDER_DISCOUNT_CODE, { credentials: 'same-origin' })
    .catch(function(){ /* tudi če aktivacija kode spodleti, prednaročilo se vseeno odda */ })
    .finally(function(){
      if (overlay) overlay.style.display = 'none';
      document.body.style.overflow = '';
      pendingPreorderAction = null;
      if (btn) { btn.disabled = false; btn.style.opacity = '1'; }
      if (typeof action === 'function') action();
    });
}

/* Uporablja se tako v cart drawer "Dodaj in prihrani" seznamu kot v
   cross-sell pojavnem oknu na strani izdelka (main-product.liquid).
   Javni klic je zdaj VEDNO najprej "ozaljšan" s prednaročilnim pop-upom
   (gatePreorder) — dejansko dodajanje v košarico se zgodi šele v
   _quickAddToCartNow, potem ko stranka potrdi prednaročilo. */
function quickAddToCart(variantId, btnEl) {
  if (!variantId) return;
  gatePreorder(function () { _quickAddToCartNow(variantId, btnEl); });
}

function _quickAddToCartNow(variantId, btnEl) {
  if (!variantId) return;
  if (btnEl) { btnEl.disabled = true; btnEl.style.opacity = '0.6'; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({items: [{id: parseInt(variantId), quantity: 1}]})
  })
    .then(function(r){
      if (!r.ok) throw new Error('add failed');
      return r.json();
    })
    .then(function(){
      updateCartCount();
      openCartDrawer();
    })
    .catch(function(){
      alert('Dodajanje ni uspelo. Poskusi znova.');
    })
    .finally(function(){
      if (btnEl) { btnEl.disabled = false; btnEl.style.opacity = '1'; }
    });
}